import { FC, ForwardedRef, forwardRef, memo } from "react";

import {
  Select as MantinSelect,
  SelectProps as MantineSelectProps,
} from "@mantine/core";
import styles from "@/shared/ui/select/ui/select.module.scss";

interface SelectProps extends Omit<MantineSelectProps, "error"> {
  width?: number;
  error?: string | boolean;
}

export const Select: FC<SelectProps> = memo(
  forwardRef(
    ({ width, error, ...props }, ref: ForwardedRef<HTMLInputElement>) => {
      return (
        <MantinSelect
          {...props}
          ref={ref}
          style={{ width: width }}
          size="md"
          error={error}
          classNames={{
            input: styles.input,
            root: styles.root,
            wrapper: styles.wrapper,
            error: styles.error_text,
          }}
        />
      );
    },
  ),
);
